import React, {createRef, RefObject} from 'react'

import RichTextEditorUniversal from "../../../gd-components/editor-universal/editor-universal"
import {EditorAIOptions} from "../../../gd-components/editor/editor";

type Props = {
    className?                          : string

    form                                : any
    name                                : string
    nameRTF                             : string

    attachmentInMessageDefaultWidth?    : number | string
    attachmentInEditorIsResizeable?     : boolean
    attachmentsCollection?              : any       // pass through used by attachments plugin

    placeholder?                        : string
    editable?                           : boolean

    onCommandEnterKey?                  : func      // ctrl+enter || command + enter handler
    onKeyDown?                          : func

    localSettingsName?                  : string

    useLocalSettings?                   : boolean      // for showControls in localSettings // TODO: rename parameter
    showControls?                       : boolean
    showFloatingControls?               : boolean
    showUndoRedo?                       : boolean
    showSettingsButton?                 : boolean
    hideControlsAllowed?                : boolean
    hidePinOption?                      : boolean
    disableSlashMenu?                   : boolean
    focusOnMount?                       : boolean

    projectId?                          : string

    ai?                                 : EditorAIOptions

    mentions?                           : any
    forceComponentsOfViewType?          : boolean

    stateSaveInterval?                  : number

    size?                               : string

    children?                           : any

    onClick?                            : func
    onPasteImage?                       : func
    onEscape?                           : func
    onChange?                           : func
}

const debug = false
// const debug = "TextAreaRTEFormElement"

export default class TextAreaRTEFormElement extends React.Component<Props> {

    refRTE: RefObject<RichTextEditorUniversal> = createRef()

    static defaultProps = {
        editable        : true,
        size            : 'normal',
        focusOnMount    : true,
        editorType      : 'default'
    }

    constructor(props:Props) {
        super(props)

        debug && console.log(debug, 'constructor', this.props)
    }

    componentDidMount() {
        this.props.form.registerFormComponent(this.props.name,this)
        this.props.form.registerFormComponent(this.props.nameRTF,this)

        //code below was added for draftail
        //causes IE11 issues in new task form if this.props.focusOnMount is not set to false
        setTimeout(()=>{if (this.props.focusOnMount && this.props.editable) this.focus()}, 100); //timeout is required for mentions plugin to work (internal plugin causes unknown)
    }

    getPrintContainer() {
        return this.refRTE.current?.getPrintContainer();
    }

    onChange = (message: string, messageRTF: any) => {
        const oldMessage    = this.props.form.getValue(this.props.name)
        const oldMessageRTF = this.props.form.getValue(this.props.nameRTF)

        const diff = gd.utils.getObjectDiff(oldMessageRTF, messageRTF)
        if (diff.length > 0 || oldMessage !== message.trim()) {
            this.props.form.onFormComponentValueChange(this.props.name,message.trim())
            this.props.form.onFormComponentValueChange(this.props.nameRTF,messageRTF)
            if (this.props.onChange) this.props.onChange(message, messageRTF)
        }
    }

    clear = () => {
        if (this.refRTE.current) this.refRTE.current.clear();
    }

    focus = () => {
        if (this.refRTE.current) this.refRTE.current.focus();
    }

    blur = () => {
        if (this.refRTE.current) this.refRTE.current.blur();
    }

    refresh = () => {
        this.forceUpdate();
    }

    addAttachmentToEditor = (fileData: any) => {
        if (this.refRTE.current) this.refRTE.current.addAttachmentToEditor(fileData)
    }

    render() {
        const message       = this.props.form.getValue(this.props.name)
        const messageRTF    = this.props.form.getValue(this.props.nameRTF)

        const classes = Classes('gd-textarea-rte', this.props.className, {
            'size-normal'   : this.props.size === 'normal',
            'size-big'      : this.props.size === 'big',
            'not-editable'  : !this.props.editable
        })

        debug && console.log(debug, 'render', this.props)

        return (
            <RichTextEditorUniversal ref                                = {this.refRTE}
                                     className                          = {classes}
                                     attachmentsCollection              = {this.props.attachmentsCollection}
                                     attachmentInMessageDefaultWidth    = {this.props.attachmentInMessageDefaultWidth}
                                     attachmentInEditorIsResizeable     = {this.props.attachmentInEditorIsResizeable}
                                     stateSaveInterval                  = {this.props.stateSaveInterval}
                                     editable                           = {this.props.editable}
                                     // forceComponentsOfViewType  = {this.props.forceComponentsOfViewType}
                                     messageText                        = {message}
                                     messageRTF                         = {messageRTF}
                                     placeholder                        = {this.props.placeholder}
                                     projectId                          = {this.props.projectId}

                                     mentions                           = {this.props.mentions}
                                     localSettingsName                  = {this.props.localSettingsName}


                                     ai                                 = {this.props.ai}


                                     useLocalSettings                   = {this.props.useLocalSettings}
                                     showControls                       = {this.props.showControls}
                                     showFloatingControls               = {this.props.showFloatingControls}
                                     showUndoRedo                       = {this.props.showUndoRedo}
                                     showSettingsButton                 = {this.props.showSettingsButton}
                                     hideControlsAllowed                = {this.props.hideControlsAllowed}
                                     hidePinOption                      = {this.props.hidePinOption}
                                     disableSlashMenu                   = {this.props.disableSlashMenu}
                                     focusOnMount                       = {this.props.focusOnMount}

                                     onCommandEnterKey                  = {this.props.onCommandEnterKey}
                                     onKeyDown                          = {this.props.onKeyDown}
                                     onPasteImage                       = {this.props.onPasteImage}
                                     onEscape                           = {this.props.onEscape}
                                     onChange                           = {this.onChange}>
                {this.props.children}
            </RichTextEditorUniversal>
        )
    }
}